import { render } from "./rzrqDetail.vue?vue&type=template&id=bfd3e55a&scoped=true&ts=true"
import script from "./rzrqDetail.vue?vue&type=script&lang=ts"
export * from "./rzrqDetail.vue?vue&type=script&lang=ts"

import "./rzrqDetail.vue?vue&type=style&index=0&id=bfd3e55a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd3e55a"]])

export default __exports__